import { Tune } from '@mui/icons-material';
import { Badge, IconButton } from "@mui/material";
import { ReactNode, useState } from "react";
import TemporaryDrawer from '../TemporaryDrawer/TemporaryDrawer';

interface MoreFiltersProps {
    children: ReactNode
    count: number
    anchor?: "left" | "right"
}

export default function MoreFilters(props: MoreFiltersProps) {

    const { children, count, anchor = "left" } = props
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const handleClick = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Badge badgeContent={count} color="error">
                <IconButton onClick={handleClick}>
                    <Tune />
                </IconButton>
            </Badge>
            <TemporaryDrawer isOpen={isOpen} setIsOpen={setIsOpen} hideBackdrop={false} anchor={anchor}>
                {children}
            </TemporaryDrawer>
        </>
    )
}
